import { ReactNode } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconMoneyTopup } from '@iwoca/icons/brand';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { useIsInDERepaymentReductionTest } from '../../../../../../customHooks/useIsInDERepaymentReductionTest';
import { BenefitsDividerSVG } from '../../../../../../svgComponents/benefitsDividerSVG/BenefitsDividerSVG';
import { OverpayLoanSVG } from '../../../../../../svgComponents/overpayLoanSVG/OverpayLoanSVG';
import { TopupSVG } from '../../../../../../svgComponents/topupSVG/TopupSVG';
import { WithdrawFundsSVG } from '../../../../../../svgComponents/withdrawFundsSVG/WithdrawFundsSVG';

const Benefit = ({
    icon,
    children
}: {
    icon: ReactNode;
    children: ReactNode;
}) => (
    <div className="flex grow flex-col gap-s min-sm:flex-row min-sm:items-center">
        <div className="shrink-0">{icon}</div>
        <Text className="text-xs min-sm:text-s">{children}</Text>
    </div>
);

export const BenefitsList = () => {
    const isInRepaymentReductionTest = useIsInDERepaymentReductionTest();

    return (
        <div
            className="border-b border-secondary-90 px-l pb-l pt-l min-sm:px-xl"
            data-testid="benefits-list"
        >
            <Text className="text-m font-med">
                <FormattedMessage
                    id="_.benefits_list.title"
                    defaultMessage="How most customers use our loans"
                />
            </Text>

            <div className="mt-m flex items-center gap-xs min-sm:gap-l">
                <Benefit icon={<WithdrawFundsSVG />}>
                    <FormattedMessage
                        id="_.benefits_list.withdraw"
                        defaultMessage="Withdraw funds as needed"
                    />
                </Benefit>

                <BenefitsDividerSVG className="shrink-0" />

                <Benefit icon={<OverpayLoanSVG />}>
                    <FormattedMessage
                        id="_.benefits_list.overpay"
                        defaultMessage="Overpay or settle early with no extra fees"
                    />
                </Benefit>

                <BenefitsDividerSVG className="shrink-0" />

                <Benefit
                    icon={
                        getCountry() === 'DE' ? (
                            <IconMoneyTopup fontSize={30} />
                        ) : (
                            <TopupSVG />
                        )
                    }
                >
                    {isInRepaymentReductionTest ? (
                        <FormattedMessage
                            id="_.benefits_list.topup_repayment_reduction"
                            defaultMessage="Top-up or reduce repayments upon request"
                        />
                    ) : (
                        <FormattedMessage
                            id="_.benefits_list.topup"
                            defaultMessage="Top up for more funds"
                        />
                    )}
                </Benefit>
            </div>
        </div>
    );
};
